import type { parsedApiError } from "@/types/api/errors.api";

export interface commonState {
    isLoading: boolean;
    isSubmitting: boolean;
    error: parsedApiError | null;
}

export type commonAction =
    | { type: "FETCH_START" }
    | { type: "FETCH_SUCCESS"; payload?: any }
    | { type: "FETCH_FAILURE"; payload: parsedApiError }
    | { type: "SUBMIT_START" }
    | { type: "SUBMIT_SUCCESS" }
    | { type: "SUBMIT_FAILURE"; payload: parsedApiError }
    | { type: "RESET_ERROR" };

export const initialCommonState: commonState = {
    isLoading: false,
    isSubmitting: false,
    error: null,
};

export const commonReducer = (
    state: commonState,
    action: commonAction,
): commonState => {
    switch (action.type) {
        case "FETCH_START":
            return { ...state, isLoading: true, error: null };
        case "FETCH_SUCCESS":
            return { ...state, isLoading: false };
        case "FETCH_FAILURE":
            return { ...state, isLoading: false, error: action.payload };

        case "SUBMIT_START":
            return { ...state, isSubmitting: true, error: null };
        case "SUBMIT_SUCCESS":
            return { ...state, isSubmitting: false };
        case "SUBMIT_FAILURE":
            return { ...state, isSubmitting: false, error: action.payload };

        case "RESET_ERROR":
            return { ...state, error: null };

        default:
            return state;
    }
};
